import React from 'react'

import Model from './Model'
import Project from './Project'
import ProjectPosition from './ProjectPosition'
import HasMatching from "./decorators/HasMatching";
import IsCandidate from "./decorators/IsCandidate";
import User from "./User";
import TalentPool from "./TalentPool";
import {Exception} from "sass";

const SortOptions = {
    Match: 'Best Match',
    Availability: 'Availability',
    KeySkills: 'Key Skills (high to low)',
    Experience: 'Total Experience (high to low)',
    IndustryExperience: 'Industry Experience (high to low)',
    Rate: 'Bill Rate (low to high)',
    Location: 'Location (near to far)',
    Name: 'Talent Name (A-Z)',
};
export default class TalentCandidate extends IsCandidate(HasMatching(Model))
{
    static Key = 'TalentCandidate';
    static SortOptions = SortOptions;

    static normalize(props) {
        if (props.bio) {
            props.bio = props.bio.replace(/<br\s*[\/]?>/gi, "\n");
        }

        return props;
    }

    static sortingOptionsFor(project)
    {
        let options = {...this.SortOptions};
        if (!project.hasSchedule()) {
            delete options.Availability;
        }

        return TB.values(options);
    }

    static matchSortingOptions()
    {
        let options = {
            approved_at: 'Recently Added',
            best_match: "Best Match (high to low)",
            min_bill_rate: 'Bill Rate (low to high)',
            max_bill_rate: 'Bill Rate (high to low)',
            experience: 'Total Experience (high to low)',
            key_skills: 'Key Skills (high to low)',
            industries: 'Industry Experience (high to low)',
            first_name: 'Talent Name (A-Z)',
        };
        if (TB.auth()?.user?.().clientOrg?.()?.location){
            options.proximity = 'Location (near to far)'
        }
        return options
    }
    fullName()
    {
        return `${this.first_name} ${this.last_name}`;
    }

    firstNamePlusInitial()
    {
        return `${this.first_name} ${this.last_name.substr(0,1)}.`;
    }

    fullJobTitle()
    {
        let title = this.job_title;
        if (!title && TB.isObject(this.supplier_client)) {
            title = "Talent Resource"
        }

        if (!title) return null

        return (
            <span>
                {title}
            </span>
        );
    }
    fullBio() {
        return this.wripple_description || this.bio
    }

    shortBio() {
        if (!this.bio && !this.wripple_description) {
            return;
        }

        if (this.wripple_description) {
            return this.wripple_description.substr(0, 64);
        }

        return this.bio.substr(0, 64);
    }

    talent()
    {
    	// if (!this.job_candidate) {
    	// 	return;
    	// }

        let {
            job_candidate = {},
            ...user
        } = this;
    	return {...user, ...job_candidate};
    }

    /*
    |--------------------------------------------------------------------------
    | Network Requests
    |--------------------------------------------------------------------------
    */
    static SearchClientProjectsRequest;

	static AddToFavoritesRequest;
	static RemoveFromFavoritesRequest;

	static AddToProjectLikedRequest;
	static RemoveFromProjectLikedRequest;

	static AddToProjectArchiveRequest;
	static RemoveFromProjectArchiveRequest;

    static RemoveFromProjectCandidatesRequest;
    static AddToProjectCandidatesRequest;

	static async runProjectRequest(project, requestProp, requestMethod, appendToUrl = '')
	{
		let user = TB.auth().user();
		if (!user
			|| !user.hasRegisteredClientOrg()) {
			return;
		}

		project = Project.make({...project});

		this[requestProp] = TB.request(
			TB.api_endpoint(`/api/clients/${user.clientOrg().id}/projects/${project.id}/${appendToUrl}`)
		);

		let response = await this[requestProp][requestMethod]().catch(console.warn);

		if (!response
			|| !response.success
			|| !response.success.data)
		{
            this[requestProp].didHandleError = await this[requestProp].handleError();
            if (this[requestProp].didHandleError
                && this[requestProp].shouldRerun) {
                return this.runProjectRequest(
                	project, requestProp, requestMethod, appendToUrl
                );
            }

			return;
		}

		return response.success.data;
	}

	static async runProjectPositionRequest(project, position, requestProp, requestMethod, appendToUrl = '')
	{
		appendToUrl = `positions/${position?.id}/candidates${appendToUrl}`;

		return this.runProjectRequest(
        	project, requestProp, requestMethod, appendToUrl
        );
	}
    static async fetchTalentCandidateScope(candidateId, requestOptions = {}) {
        const fetchTalentCandidateScopeRequest = TB.request(
            TB.api_endpoint(`/api/job-candidates/talent-users/${candidateId}/scope`)
        );


        let response = await fetchTalentCandidateScopeRequest.get(requestOptions).catch(console.warn);


        if (!TB.get(response, 'success.data.talent_user')) {
            throw new Error('Something went wrong')
        }

        let candidate = {...response.success.data.talent_user };

        return this.make({...candidate})
    }

    static async fetchTalentReviews(params, requestOptions = {}) {
        this.FetchTalentReviewsRequest = TB.request(
            TB.api_endpoint(`/api/reviews/talent-users/${params.talent_id}`),
        );

        let response = await this.FetchTalentReviewsRequest.get(requestOptions).catch(e => {
            throw new Error(e.message)
        })

        if (!TB.has(response, 'success.data.reviews')) {
            throw new Error('Something Went Wrong')
        }

        return response.success.data.reviews
    }

    static async addReviewToTalent(talent_id, props) {
        console.log({ talent_id, props })
        this.addReviewToTalentRequest = TB.request(
            TB.api_endpoint(`/api/reviews/talent-users/${talent_id}/create`), {...props}
		);

		const response = await this.addReviewToTalentRequest.post().catch(console.warn);

        console.log(response, 'RESPONSEEEEEE')

        if (!response || !TB.has(response, 'success')) {
            return false;
        }

        return response.success.data.review
    }

    static async deleteReviewToTalent(review_id, props) {
        console.log({ review_id, props })

        this.deleteReviewToTalentRequest = TB.request(
            TB.api_endpoint(`/api/reviews/${review_id}/delete`)
		);

		const response = await this.deleteReviewToTalentRequest.post().catch(console.warn);

        console.log(response, 'RESPONSEEEEEE')

        if (!response || !TB.has(response, 'success')) {
            return false;
        }

        return response.success.data
    }

    static async coverLetterChatGPT(position, props) {
        this.coverLetterChatGPTRequest = TB.request(
            TB.api_endpoint(`/api/talent-project-positions/${position}/generate-proposal-draft`),
            {...props}
		);

		const response = await this.coverLetterChatGPTRequest.post().catch(console.warn);

        if (!response || !TB.has(response, 'success')) {
            return false;
        }


        return response.success.data //.success.data.review
    }
    static async coverLetterChatGPTAdjust(position, conversation, prompt) {
        this.coverLetterChatGPTAdjustRequest = TB.request(
            TB.api_endpoint(`/api/talent-project-positions/${position}/generate-proposal-draft/adjust`),
            {conversation, prompt, "json": true}
		);

		const response = await this.coverLetterChatGPTAdjustRequest.post().catch(console.warn);

        if (!response || !TB.has(response, 'success')) {
            return false;
        }

        // !!DUMMY TEST DATA TO NOT HIT CHATGPT FOR API CALLS TESTING!!

        // const response = {
        //     success: {
        //         data: {
        //             proposal: {
        //                 cover_letter: "<p>With over four years of experience in mental health counseling, my diverse skill set and background make me a perfect candidate for the Content Strategist role at Acme, Inc. I am particularly excited by the opportunity to leverage my extensive experience in graphic design, content creation, and brand strategy development to contribute to innovative and captivating creative ideas.</p><p>Having worked with industry leaders such as Universal and Stanley Black & Decker, I am well-versed in creating compelling content across various platforms. My technical prowess with tools like Adobe Creative Cloud and Adobe Photoshop, combined with my ability to develop editorial guidelines and calendars, make me confident in handling the responsibilities of your listed deliverables such as Paid Social Creative Concepts and Site Wireframes.</p><p>Moreover, my experience in content design and strategy has afforded me strong project management skills, necessary for coordinating with stakeholders and ensuring timely delivery of high-quality work. My background in science equips me with a unique analytical perspective, enhancing my ability to perform precise content audits and user experience assessments.</p><p>I am keen to bring my background in diverse industries, including healthcare and oil and gas, to your team. I am also open to traveling for work and adapting to a dynamic work environment that demands both onsite and remote collaboration.</p><p>I look forward to the possibility of discussing how my experience and skills align with the needs of your team.</p>",
        //                 relevant_experience: "<p><strong>Wyman, Balistreri and Wilderman</strong><br>Sheet Metal Worker<br><em>November 2006 - Present</em></p><p><strong>Roberts, Torp and Bode</strong><br>Communications Equipment Operator<br><em>November 2017 - Present</em><br>Laboriosam labore sequi dolores omnis odit dolorum. Et voluptates et tempora optio.</p><p><strong>Mayer-Schuster</strong><br>Structural Metal Fabricator<br><em>February 2020 - October 2023</em><br>Voluptatibus et consequuntur ut. Provident corporis ipsa tenetur unde nesciunt voluptate. Eius sed consectetur minima assumenda ea aut.</p><p><strong>Portfolio Highlights</strong><br><em>Universal</em> - 2013<br><em>22Squared Inc.</em> - 2019: Incidunt aut enim eos eius. Neque iusto quia est nostrum aut. Facere quod laudantium ut illo harum cupiditate.<br><em>Stanley Black & Decker</em> - 2024: Alias quasi consequatur ipsam qui maxime dolor cumque. Assumenda ratione possimus voluptatem iusto illo aperiam.<br><em>CarpeDM</em> - 2018: Eos nisi commodi molestias enim. Eveniet sint rerum nihil quia optio. Quia fugit ea non odit sed et sit. Consequatur sunt sint ea voluptas vero hic libero.</p><p><strong>Education</strong><br><em>Arizona School of Science</em><br>M.A. in Science<br><em>March 2008 - February 2019</em></p><p>Beyond this experience, I have developed a range of skills over 11+ years in HTML/CSS, Adobe InDesign, and Adobe Creative Cloud, and up to 10 years in business analysis and content strategy, aligning with the qualifications and responsibilities of the Content Strategist role.</p>",
        //             },
        //         },
        //         message: null,
        //         status: 200,
        //     }
        // };

        return {
            ...response.success.data,
            proposal: response.success.data.reply
        } //.success.data.review
    }

    static async addTalentRoleAppeal(discipline_id, props) {
        await TB.wait(500)

        this.addTalentRoleAppealRequest = TB.request(
            TB.api_endpoint(`/api/appeals/talent-user-disciplines/${discipline_id}/create`), props
		);

		const response = await this.addTalentRoleAppealRequest.post().catch(err => {
            throw new Error(err.response?.data?.error?.data?.detail)
        });

        if (!response || !TB.has(response, 'success')) {
            return response;
        }

        return response.success.data
    }

    static async addTalentProfileAppeal(props) {
        await TB.wait(500)

        this.addTalentRoleProfileRequest = TB.request(
            TB.api_endpoint('/api/appeals/talent-user-profile/create'), props
		);

		const response = await this.addTalentRoleProfileRequest.post().catch(err => {
            throw new Error(err.response?.data?.error?.data?.detail)
        });

        if (!response || !TB.has(response, 'success')) {
            return response;
        }

        return response.success.data
    }


    async searchProjectsForClient(search)
    {
        let user = TB.auth().registeredClientUser();
        if (!user) {
            return;
        }

        await this.constructor.cancelRequest('SearchClientProjectsRequest')

        this.constructor.SearchClientProjectsRequest = TB.request(
            TB.api_endpoint(`/api/clients/${TB.auth().user()?.clientOrg().id}/talent-users/${this.id}/search`),
            {search: search}
        );

        let request = this.constructor.SearchClientProjectsRequest;

        let response = await request.get().catch(console.warn);

        if (request.wasCancelled) {
            return;
        }

        if (!TB.has(response, 'success.data.projects')) {
            return;
        }

        return Project.makeMany([...response.success.data.projects]);
    }

    /*
    |--------------------------------------------------------------------------
    | Cache
    |--------------------------------------------------------------------------
    */

    static clearCache()
    {
    	// TODO Reset Queries
        this.Cached = undefined;
    }
    /*
   |--------------------------------------------------------------------------
   | Position Scope
   |--------------------------------------------------------------------------
   */

    canConfirmScope = () => {
        let missingDeliverables = TB.filter(this.job_candidate?.position_deliverables, del => !del.total_hours)

        return missingDeliverables?.length <= 0;
    }

    canEditTeamScope() {
        return !this.statusIsRejected() && !this.statusIsWithdrawn() && !this.statusIsApproved()
    }

    scopeStatusForPosition(position) {
        let talentOpp = this.job_candidate?.talent_opps?.[0];
        let statusLabel = '';
        let statusColor = TB.config('color.gray');
        if (this.matchStatusIsInterested() && !this.job_candidate.talent_invited_at) {
            statusColor = TB.config('color.secondary');
            statusLabel = 'Interested, Proposal Ready';
            if (!this.hasConfirmedPayout()) {
                statusLabel += ' (Payout Needs Confirmation)'
            }else {
                statusLabel += ' (Payout Confirmed, Awaiting Invite)'
            }
        } else if (!!talentOpp.withdrew_at) {
            statusColor = TB.config('color.danger-darker');
            statusLabel = 'Withdrew from opportunity';
        } else if (!!talentOpp.rejected_at) {
            statusColor = TB.config('color.danger');
            statusLabel = 'Rejected';
        } else if (!!talentOpp.accepted_at) {
            if (this.hasConfirmedPayout()) {
                statusLabel = 'Accepted (Payout Confirmed)'
                statusColor = TB.config('color.success');
            } else {
                const hasProposedPayout = !this.job_candidate.matches_payout;
                if (hasProposedPayout) {
                    statusLabel = 'Accepted with proposed changes';
                    statusColor = TB.config('color.warning');
                } else {
                    TB.config('color.info');
                    statusLabel = 'Accepted (Payout Needs Confirmation)'
                }
            }
        } else {
            statusColor = TB.config('color.gray');
            statusLabel = 'Invite Sent (No Response Yet)';
        }

        if (position.hasBeenFilled() && this.job_candidate?.id === position.assigned_candidate?.job_candidate?.id) {
            statusColor = TB.config('color.secondary');
            statusLabel = 'Selected For Role';
        }
        return [statusLabel, statusColor]
    }

    canAcceptPayout = () => {
        let talentOpp = this.job_candidate?.talent_opps[0];

        return !talentOpp?.rejected_at && !talentOpp?.withdrew_at && (!!talentOpp?.accepted_at || (this.matchStatusIsInterested() && !this.job_candidate.talent_invited_at))
    }

    static normalizeScopeForPosition = (candidate, position) => {

        let candidateData = candidate.job_candidate;
        let talent_opps = TB.map(candidateData.talent_opps, opp => {
            let user = {...candidate};
            delete user.job_candidate;

            if (opp.position_deliverables) {
                opp.position_deliverables = TB.map([...opp.position_deliverables], del => {
                    let matchedDel = TB.find(position.deliverables, ['id', del.id])

                    return {...del, original_total_periods: matchedDel?.total_hours, original_payout_amount: matchedDel?.payout_amount}
                })
            }
            opp.user = User.make(user)
            return opp;
        });
        let {
            hourly_rate,
            total_hours,
            payout_amount
        } = {...candidateData}

        const standard_hourly_rate = parseFloat(position.platform_rate);
        const standard_total_periods = parseInt(TB.sumBy(position.deliverables, 'total_hours'));
        const standard_payout_amount = parseInt(TB.sumBy(position.deliverables, 'payout_amount'));
        const matches_hourly_rate= !hourly_rate || parseFloat(hourly_rate) === standard_hourly_rate;
        const matches_total_periods = !total_hours || parseInt(total_hours) === standard_total_periods;
        const matches_payout = !payout_amount || parseFloat(payout_amount) === standard_payout_amount;

        return TalentCandidate.make({...candidate, job_candidate: {
                ...candidateData,
                talent_opps,
                hourly_rate,
                total_hours,
                standard_hourly_rate,
                standard_total_periods,
                standard_payout_amount,
                matches_hourly_rate,
                matches_total_periods,
                matches_payout
            }})
    }
        /*
        |--------------------------------------------------------------------------
        | Assign/Unassign to Position
        |--------------------------------------------------------------------------
        */

    async assignToPosition(project, position)
    {
    	let responseData = await this.constructor.runProjectPositionRequest(
			project, position, 'AssignToProjectPositionRequest', 'post', `/${this.id}/assign`
		);

    	if (!responseData?.user) {
			return;
		}

        let candidate = TalentCandidate.make(responseData?.user)

        let updatedPosition = ProjectPosition.make({
            ...position,
            is_filled: true,
            assigned_candidate: candidate
        });

        let updatedProject = project;

        if (responseData.project) {
            updatedProject = Project.make({...responseData.project})

            updatedPosition = TB.find(updatedProject.positions,['id', position.id]);

            updatedPosition = ProjectPosition.make({...updatedPosition});
        }

        await updatedPosition.resetCandidateQueryDataForProject(candidate, updatedProject)

        return candidate;
    }

    async unassignFromPosition(project, position)
    {
    	let responseData = await this.constructor.runProjectPositionRequest(
			project, position, 'UnassignFromProjectPositionRequest', 'post', `/${this.id}/unassign`
		);


		if (!responseData?.user) {
			return;
		}

        let candidate = TalentCandidate.make(responseData?.user)

        let updatedPosition = ProjectPosition.make({
            ...position,
            is_filled: false,
            assigned_candidate: false
        });

        let updatedProject = project;

        if (responseData.project) {
            updatedProject = Project.make({...responseData.project})

            updatedPosition = TB.find(updatedProject.positions,['id', position.id]);

            updatedPosition = ProjectPosition.make({...updatedPosition});
        }

        await updatedPosition.resetCandidateQueryDataForProject(candidate, updatedProject)

		return candidate;
    }

    /*
    |--------------------------------------------------------------------------
    | Add/Remove to/from Shortlist
    |--------------------------------------------------------------------------
    */

    async addToCandidates(project, position)
    {
    	let responseData = await this.constructor.runProjectPositionRequest(
			project, position, 'AddToProjectCandidatesRequest', 'post', `/${this.id}/shortlist`
		);

        if (!TB.has(responseData, 'user')) {
            return false;
        }
        let candidate = TalentCandidate.make(responseData.user)

        let updatedPosition = ProjectPosition.make({
            ...position,
            has_candidates: true,
            total_selected_candidates: position.total_selected_candidates + 1
        });

        await updatedPosition.resetCandidateQueryDataForProject(candidate, project)

		return candidate;
    }

    async removeFromCandidates(project, position, append = '')
    {
        let params = '?';
        if (this.declinedPosition() && !this.job_candidate?.was_disliked) {
            params += 'self_disliked=1&'
        }
        params += append
    	let responseData = await this.constructor.runProjectPositionRequest(
			project, position, 'RemoveFromProjectCandidatesRequest',
            'post',
            `/${this.id}/undo-shortlist` + params
		).catch(error => console.warn(error));

        if (!TB.has(responseData, 'user')) {
            if (TB.has(this.constructor.RemoveFromProjectCandidatesRequest.response, 'error.data.has_confirmed_interview_cancellation')) {

                let confirmInterviewCancellation = await TB.sysAlert('client.pending_interview_cancellation_on_removing_candidate');
                if(confirmInterviewCancellation) {
                    return this.removeFromCandidates(project, position, 'has_confirmed_interview_cancellation=true')
                }
            }
            return false;
        }

        let candidate = TalentCandidate.make(responseData?.user)

        let total_selected_candidates = position.total_selected_candidates - 1

        let updatedPosition = ProjectPosition.make({
            ...position,
            has_candidates: total_selected_candidates > 0,
            total_selected_candidates
        });

        if (params.includes('self_disliked')) {
            await updatedPosition.resetCandidateQueryDataForTalent(candidate, page => {
                page.self_disliked_total = page.self_disliked_total + 1;
                page.disliked_total = page.disliked_total + 1;
                return page;
            });

            if (project) {
                await updatedPosition.refreshInProjectCacheFor(project)
            }
        }else {
            await updatedPosition.resetCandidateQueryDataForProject(candidate, project)
        }
		return candidate;
    }

    /*
    |--------------------------------------------------------------------------
    | Override Client Preferred Rate
    |--------------------------------------------------------------------------
    */

    async overrideClientPreferredRate(rate, project, position)
    {
        let user = TB.auth().user();
        if (!user
            || !user.hasRegisteredClientOrg() ||
            !user.canManageClients()) {
            throw new Error("Unauthorized")
        }
        if (!rate && this.client_override_hourly_rate) {
            return this.removeClientPreferredRate(project, position)
        }
        const percentMarkup = this.markup_multiplier ? (this.markup_multiplier - 1) : user.clientOrg()?.defaultPercentMarkup()

        TalentCandidate.OverrideClientPreferredRateRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg()?.id}/talent-users/${this.id}/rate/store`),
            {hourly_rate: rate}
        );

        let response = await TalentCandidate.OverrideClientPreferredRateRequest.post().catch(console.warn);

        if (!TB.has(response, 'success')) {
            TalentCandidate.OverrideClientPreferredRateRequest.didHandleError = await TalentCandidate.OverrideClientPreferredRateRequest.handleError();
            if (TalentCandidate.OverrideClientPreferredRateRequest.didHandleError
                && TalentCandidate.OverrideClientPreferredRateRequest.shouldRerun) {
                return this.overrideClientPreferredRate(rate, project, position);
            }

            throw new Error("Something went wrong")
        }
        this.client_override_hourly_rate = rate;
        this.client_override_platform_rate = Math.ceil(rate * (1 + percentMarkup));

        if (position) {
            if (!(position instanceof ProjectPosition)) {
                position = ProjectPosition.make({...position});
            }

            await position.resetCandidateQueryDataForTalent(this, page => {
                return page;
            });
        }

        await TalentPool.refreshTalentPoolMember(this)

        return this;
    }
    async removeClientPreferredRate(project, position)
    {
        let user = TB.auth().user();
        if (!user
            || !user.hasRegisteredClientOrg() ||
            !user.canManageClients()) {
            throw new Error("Unauthorized")
        }

        TalentCandidate.RemoveClientPreferredRateRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg()?.id}/talent-users/${this.id}/rate/delete`),
        );

        let response = await TalentCandidate.RemoveClientPreferredRateRequest.post().catch(console.warn);

        if (!TB.has(response, 'success')) {
            TalentCandidate.RemoveClientPreferredRateRequest.didHandleError = await TalentCandidate.RemoveClientPreferredRateRequest.handleError();
            if (TalentCandidate.RemoveClientPreferredRateRequest.didHandleError
                && TalentCandidate.RemoveClientPreferredRateRequest.shouldRerun) {
                return this.removeClientPreferredRate(project, position);
            }

            throw new Error("Something went wrong")
        }
        this.client_override_hourly_rate = undefined;
        this.client_override_platform_rate = undefined;

        if (position) {
            if (!(position instanceof ProjectPosition)) {
                position = ProjectPosition.make({...position});
            }

            await position.resetCandidateQueryDataForTalent(this, page => {
                return page;
            });
        }

        await TalentPool.refreshTalentPoolMember(this)

        return this;
    }
    /*
    |--------------------------------------------------------------------------
    | Add/Remove to/from Favorites
    |--------------------------------------------------------------------------
    */

    async addToFavorites(project, position)
    {
        let user = TB.auth().user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }


        TalentCandidate.AddToFavoritesRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/talent-users/${this.id}/favorite`)
        );

        let response = await TalentCandidate.AddToFavoritesRequest.post().catch(console.warn);

        if (!TB.has(response, 'success')) {
            TalentCandidate.AddToFavoritesRequest.didHandleError = await TalentCandidate.AddToFavoritesRequest.handleError();
            if (TalentCandidate.AddToFavoritesRequest.didHandleError
                && TalentCandidate.AddToFavoritesRequest.shouldRerun) {
                return this.addToFavorites();
            }

            return;
        }
        this.is_favorite = true;

        this.matching_pools = [...(this.matching_pools || []), {id: TalentPool.favoritedPoolId, name: 'Favorites'}]

        if (position) {
            if (!(position instanceof ProjectPosition)) {
                position = ProjectPosition.make({...position});
            }

            await position.resetCandidateQueryDataForTalent(this, page => {
                page.favorites_total = page.favorites_total + 1;
                return page;
            });
        }

        await TalentPool.onFavoriteUpdated(this.id, true)

        return this;
    }

    async removeFromFavorites(project, position)
    {
        let user = TB.auth().user();
        if (!user
            || !user.hasRegisteredClientOrg()) {
            return;
        }


        TalentCandidate.RemoveFromFavoritesRequest = TB.request(
            TB.api_endpoint(`/api/clients/${user.clientOrg().id}/talent-users/${this.id}/unfavorite`)
        );

        let response = await TalentCandidate.RemoveFromFavoritesRequest.post().catch(console.warn);

        if (!TB.has(response, 'success')) {
            TalentCandidate.RemoveFromFavoritesRequest.didHandleError = await TalentCandidate.RemoveFromFavoritesRequest.handleError();
            if (TalentCandidate.RemoveFromFavoritesRequest.didHandleError
                && TalentCandidate.RemoveFromFavoritesRequest.shouldRerun) {
                return this.addToFavorites();
            }

            return;
        }

        this.is_favorite = false;
        this.matching_pools = TB.filter([...(this.matching_pools || [])], pool => pool?.id !== TalentPool.favoritedPoolId)

        if (position) {
            if (!(position instanceof ProjectPosition)) {
                position = ProjectPosition.make({...position});
            }

            await position.resetCandidateQueryDataForTalent(this, page => {
                page.favorites_total = page.favorites_total - 1;
                return page;
            });
        }

        await TalentPool.onFavoriteUpdated(this.id, false)

        return this;
    }

    /*
    |--------------------------------------------------------------------------
    | Add/Remove to/from Liked
    |--------------------------------------------------------------------------
    */
    async addToLiked(project, position)
    {
        let responseData = await this.constructor.runProjectPositionRequest(
            project, position, 'AddToProjectLikedRequest', 'post', `/${this.id}/like`
        );

        if (!TB.has(responseData, 'user')) {
            return false;
        }
        let candidate = TalentCandidate.make(responseData.user)

        if (!(position instanceof ProjectPosition)) {
            position = ProjectPosition.make({...position});
        }

        await position.resetCandidateQueryDataForTalent(candidate, page => {
            if (!this.job_candidate?.likes?.length) {
                page.liked_total = page.liked_total + 1;
            }
            page.self_liked_total = page.self_liked_total + 1;
            return page;
        });

        return candidate;
    }

    async removeFromLiked(project, position)
    {
        let responseData = await this.constructor.runProjectPositionRequest(
            project, position, 'RemoveFromProjectLikedRequest', 'post', `/${this.id}/undo-like`
        );

        if (!TB.has(responseData, 'user')) {
            return false;
        }
        let candidate = TalentCandidate.make(responseData.user)

        if (!(position instanceof ProjectPosition)) {
            position = ProjectPosition.make({...position});
        }

        await position.resetCandidateQueryDataForTalent(candidate, page => {
            if (this.job_candidate?.likes?.length === 1) {
                page.liked_total = page.liked_total - 1;
            }
            page.self_liked_total = page.self_liked_total - 1;
            return page;
        });

        return candidate;
    }


    static async bulkAddToTalentToPool(clientId, talentPoolId, talentUserIds) {
        this.bulkAddTalentToPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${clientId}/talent-pools/${talentPoolId}/talent-users/attach`), {talent_users: talentUserIds}
		);

		const response = await this.bulkAddTalentToPoolRequest.post().catch(console.warn);

        if (!response || !TB.has(response, 'success')) {
            throw new Exception("Something went wrong");
        }

        return true;
    }
    static async addTalentToPool(clientId, talentPoolId, talentUserId, props) {
        this.addTalentToPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${clientId}/talent-pools/${talentPoolId}/talent-users/${talentUserId}/attach`), {...props}
		);

		const response = await this.addTalentToPoolRequest.post().catch(console.warn);


        if (!response || !TB.has(response, 'success')) {
            throw new Exception("Something went wrong");
        }

        return true;
    }

    static async removeTalentFromPool(clientId, talentPoolId, talentUserId, props) {
        this.removeTalentFromPoolRequest = TB.request(
            TB.api_endpoint(`/api/clients/${clientId}/talent-pools/${talentPoolId}/talent-users/${talentUserId}/detach`), {...props}
		);

		const response = await this.removeTalentFromPoolRequest.post().catch(console.warn);

        if (!response || !TB.has(response, 'success')) {
            throw new Error("Something went wrong");
        }

        return true;
    }

    static async inviteByGroup(clientId, model) {
        const body = {
            client_id: clientId,
            file: model.document_path,
            user_type: laravel.user_types.talent,
        }

        this.inviteByGroupRequest = TB.request(
            TB.api_endpoint("/api/platform-referrals/csv-import"), {...body}
		);

        this.inviteByGroupRequest.headers({
            'Content-Type': 'multipart/form-data'
        })

		// const response = await this.inviteByGroupRequest.post().catch(console.warn);
		const response = await this.inviteByGroupRequest.post().catch(e => {
            switch (e.response.data.error?.message) {
                case 'invalid_input_format':
                    throw new Error(e.response.data.error.data?.file[0])
                default:
                    break;
            }
        });

        if (!response || !TB.has(response, 'success')) {
            throw new Error('Something went wrong')
        }

        return response.success.data.platform_referrals;
    }

    static async inviteByEmail(clientId, model) {
        const body = {
            client_id: clientId,
            user_type: laravel.user_types.talent,
            ...model,
        }

        this.inviteByEmailRequest = TB.request(
            TB.api_endpoint("/api/platform-referrals/create"), {...body}
		);

		// const response = await this.inviteByEmailRequest.post().catch(console.warn);
		const response = await this.inviteByEmailRequest.post().catch(e => {
            switch (e.response.data.error?.message) {
                case 'invalid_input_format':
                    throw new Error(e.response.data.error.data?.email[0])
                default:
                    break;
            }
        });

        if (!response || !TB.has(response, 'success')) {
            // return false;
            throw new Error('Something went wrong')
        }

        return true;
    }

    /*
    |--------------------------------------------------------------------------
    | Add/Remove to/from Archive
    |--------------------------------------------------------------------------
    */
    async addToArchive(project, position)
    {
    	let responseData = await this.constructor.runProjectPositionRequest(
			project, position, 'AddToProjectArchiveRequest', 'post', `/${this.id}/dislike`
		);

        if (!TB.has(responseData, 'user')) {
            return false;
        }
        let candidate = TalentCandidate.make(responseData.user)

        if (!(position instanceof ProjectPosition)) {
            position = ProjectPosition.make({...position});
        }

        await position.resetCandidateQueryDataForTalent(candidate, page => {
            page.self_disliked_total = page.self_disliked_total + 1;
            page.disliked_total = page.disliked_total + 1;
            return page;
        });

        return candidate;
    }

    async removeFromArchive(project, position)
    {
    	let responseData = await this.constructor.runProjectPositionRequest(
			project, position, 'RemoveFromProjectArchiveRequest', 'post', `/${this.id}/undo-dislike`
		);

        if (!TB.has(responseData, 'user')) {
            return false;
        }
        let candidate = TalentCandidate.make(responseData.user)

        if (!(position instanceof ProjectPosition)) {
            position = ProjectPosition.make({...position});
        }

        await position.resetCandidateQueryDataForTalent(candidate, page => {
            page.self_disliked_total = page.self_disliked_total - 1;
            page.disliked_total = page.disliked_total - 1;
            return page;
        });

        return candidate;
    }

    /*
    |--------------------------------------------------------------------------
    | Candidate Helper
    |--------------------------------------------------------------------------
    */
    changedAvgHoursPerWeek(position) {
        return this.hasProposalForClient() &&
            this.hasSubmittedProposal() &&
            this.job_candidate?.confirmed_avg_hours_per_period &&
            parseInt(this.job_candidate?.confirmed_avg_hours_per_period) !== parseInt(position.avg_hours_per_period)
    }

    changedStartDate(position = this.position) {
        return this.hasProposalForClient() &&
            this.hasSubmittedProposal() &&
            this.confirmedStartedAt() &&
            !TB.moment(position.started_at).isSame(this.confirmedStartedAt(), 'day')
    }

    hasRequestedChangesToAvailability(position) {
        return this.changedHourlyRate(position) || this.changedAvgHoursPerWeek(position) || this.changedStartDate(position)
    }

    isFavorited() {
        return this.matching_pools?.length > 0 && !!TB.find(this.matching_pools, ['id', TalentPool.favoritedPoolId]);
    }
    isInNetwork() {
        return this.matching_pools?.length > 0 && !!TB.find(this.matching_pools, ['id', TalentPool.talentInvitesPoolId]);
    }
    isPastHire() {
        return this.matching_pools?.length > 0 && !!TB.find(this.matching_pools, ['id', TalentPool.pastHiresPoolId]);
    }
    isWrippleRecommended() {
        return this.matching_pools?.length > 0 && !!TB.find(this.matching_pools, ['name', 'Wripple Recommended']);
    }
    isInTalentPool() {

        let pools = [...(this.matching_pools || [])];
        // filter out any general talent pools (i.e. has a positive ID)
        return TB.filter(pools, pool => parseInt(pool.id) > 0 && pool.name !== 'Wripple Recommended')?.length > 0
    }
}